import $ from 'jquery'
import Nav from 'scoreboard/components/nav'
import ScorecardsGardener from './scorecards-gardener'
import conductor from 'scoreboard/components/conductor'
import ScorecardNode from './scorecard-node'
import RootForm from './root-form'
import appDisplay from 'scoreboard/components/app-display'
import _ from 'lodash'
import globals from 'scoreboard/components/globals'
import permissions from 'scoreboard/components/permissions'
import i18n from 'scoreboard/components/i18n'
import guard from 'scoreboard/components/unsaved/guard'
import { locked } from './edit/scorecards-paste-allowed'
import Tooltip from 'scoreboard/components/tooltip'
import emptyTree from 'scoreboard/components/empty-tree.hbs'
import notVisibleMessage from 'scoreboard/scorecards/not-visible-message'
import config from 'scoreboard/components/config'
import Backbone from 'backbone'
import * as AddTypes from 'scoreboard/components/add-types'
const { SIBLING } = AddTypes
import BusyButton from 'scoreboard/components/busy-button'
import ErrorView from 'scoreboard/components/error-view'
import ScorecardItemImportWizard from 'scoreboard/scorecards/edit/import/scorecard-item-import-wizard'
import { isV5 } from 'scoreboard/components/version'

var ScorecardsNav = Nav.extend({

	section: 'scorecards',
	folders: false,
	Gardener: ScorecardsGardener,
	Model: ScorecardNode,

	events: _.extend({}, Nav.prototype.events, {
		'click .create-first': 'createRoot',
		'click .create-root-docking': 'createRootDocking',
		'click .new': 'createNonRoot',
		'click .import': 'importStructure'
	}),

	_gardener: function() {
		let finderBackground = isV5() ? 'dim' : 'light'

		return new this.Gardener({
			section: this.section,
			id: this.options.id,
			orgId: this.options.orgId,
			// #9234 pass along periodId so nodes are filtered by start/archive
			// date
			periodId: globals.periodId,
			showColors: true,
			autoSelectRoot: this.options.autoSelectRoot,
			params: {
				pendingDeletion: true,
				sourceType: true
			},
			finderOptions: {
				type: this.options.searchType || finderBackground
			}
		})
	},

	_bindEvents: function(node) {
		Nav.prototype._bindEvents.apply(this, arguments)
		this.listenTo(this.gardener, 'select', this._toggleNewButton.bind(this))
		this.listenTo(this.gardener, 'node', function(node) {
			if (node.id == this.options.id) {
				this._toggleNewButton(node)
			}
		}.bind(this))
		this._onceTreeLoaded(function() {
			this.gardener.tree.on('dndstart', this.lockedTooltip.bind(this))
		}.bind(this))
		this.listenTo(this.gardener, 'change:nodeVisibility', this._toggleRootVisible.bind(this))
		this.on('toggleTree', this._handleTreeToggle.bind(this))

		//updates to the scorecard may cause the new button to enable/disable
		this.listenTo(Backbone, 'edit:domain-object', (model) => {
			this._toggleNewButton(_.clone(model.attributes))
		})
	},

	_emptyTree: function(options = {}) {
		let opts = {
			noCreateOption: _.isUndefined(options.noCreateOption) ? !permissions.structure(this.gardener.getOrgId()) : options.noCreateOption
		}

		let buttonClass = isV5() ? 'button-dark' : 'button-default'

		if (config.replicationInputEnabled) {
			// #18528 don't allow root creation on the high side
			opts.noCreateOption = true
			opts.noTypeText = 'common.replication.orgEmptyScorecards.sipr'
		}

		if (options.organizationTemplateId) {
			// #21496 If the organization is a template copy, the user cannot manually
			// create a scorecard
			opts.noCreateOption = true
		}

		Nav.prototype._emptyTree.call(this, opts)

		// add import scorecard items button
		if (opts.noCreateOption == false) {
			let importButton =
				`<button class="button ${buttonClass} import">` +
					i18n.get('scorecards.importScorecardItems') +
				'</button>'
			this.$('.empty-tree .button-container').append(importButton)
			this._importButton = new BusyButton({el: this.$('.import')})
			// #30386 update the "create" message for more than 1 button
			let msg = i18n.get('common.missing.domainObject.2.multipleButtons')
			this.$('.create').text(msg)
		}

		//add root docking node option
		if (config.replicationOutputEnabled && !options.organizationTemplateId) {
			let createRootDockingButton =
				`<button class="button ${buttonClass} create-root-docking">` +
					i18n.get('scorecards.node.docking.create') +
				'</button>'
			this.$('.empty-tree .button-container').append(createRootDockingButton)
			this._rootDockingButton = new BusyButton({el: this.$('.create-root-docking')})
		}
	},

	_toggleRootVisible: function(isVisible) {
		if (this.gardener.tree && this.gardener.tree.root.visible == false) {
			this.toggleTree(false)
			this.$el.empty().append(emptyTree({
				sectionIcon: 'scorecard',
				noTypeText: this._getNotVisibleMessage(),
				noCreateOption: true
			}))
		} else {
			this.toggleTree(true)
		}
	},

	_getNotVisibleMessage: function () {
		let archive = this.gardener.tree.get(this.gardener.tree.root.id).archive
		let start = this.gardener.tree.get(this.gardener.tree.root.id).start
		return notVisibleMessage(archive, start)
	},

	_handleTreeToggle: function(show) {
		// If the tree's root node is not visible, we need to handle that with this._toggleRootVisible.
		// There, the empty text is inserted and this method is called again with
		// the correct 'show' param (false).
		this._onceTreeLoaded(() => {
			if (show && _.get(this.gardener.tree, 'root.visible') == false) {
				this._toggleRootVisible(false)
			}
		})
	},

	// toggle whether the new button is disabled based on the currently
	// selected node
	_toggleNewButton: function(node) {
		if (!node) { return }

		this._onceTreeLoaded(() => {
			let replicated = !_.isNil(node.syncId)
			this.newButtonDisabledMessage = null
			// #9199 disable the button if a new node can't be created, and add
			// a tooltip
			if (node.id && locked(node, this.gardener.tree)) {
				this.newButtonDisabledMessage = 'integrity.scorecards.outsideLockPeriod.tooltip'
			} else if (node.type === 'docking' || (replicated && !node.originallyDocked) || node.dereferenced) {
				// nothing is allowed under docking nodes or replicated nodes (unless it's a transformed docking)
				this.newButtonDisabledMessage = 'scorecards.error.cannotAddChildNode'
			}
			this.$('.new').toggleClass('is-disabled', this.newButtonDisabledMessage != null)
		})
	},

	_toggleNewDomainObjectButton() {
		Nav.prototype._toggleNewDomainObjectButton.apply(this, arguments)
		let selected = this.gardener.tree.selected()
		this._toggleNewButton(selected)
	},

	// #9199 show a tooltip if a new node can't be created
	_showDisabledAddTooltip (evt, msgKey) {
		evt.stopPropagation()
		_.invoke(this._disabledAddTooltip, 'remove')
		this._disabledAddTooltip = new Tooltip({
			attachTo: evt.target,
			content: i18n.get(msgKey),
			placement: 'below',
			arrow: 'center'
		}).render()
	},

	// create a new scorecard root in an org that doesn't have a scorecard
	createRoot: function() {
		if (config.replicationOutputEnabled && this._rootDockingButton.state == 'loading') return

		var scorecard = new ScorecardNode({ organizationId: globals.orgId })
		appDisplay.dialog($.get('api/tags'), globalTags => {
			return new RootForm({ model: scorecard, globalTags })
		})
	},

	createRootDocking() {
		if (this._rootDockingButton.state == 'loading') return

		this._rootDockingButton.loading()
		let scorecard = new ScorecardNode({ organizationId: globals.orgId,
			type: 'docking', label: i18n.get('scorecards.node.docking') })
		scorecard.save(null, {
			success: (model) => {
				this.options.id = model.id
				this.render()
				conductor.navigate('scorecards/' + model.id, { trigger: true })
			},
			error: (model, res) => {
				appDisplay.dialog(new ErrorView(res.responseJSON))
				this._rootDockingButton.enable()
			}
		})
	},

	// create a non-root scorecard node in an existing scorecard
	createNonRoot: function(e) {
		if (this.newButtonDisabledMessage) {
			this._showDisabledAddTooltip(e, this.newButtonDisabledMessage)
			return
		}
		this._onceTreeLoaded(() => {
			guard.conditionallyRun(() => {
				//#22286 ensure the correct parent id is used
				let node = this.gardener.tree.get(conductor.id())
				let parentId = this.gardener.getAddType(node) === SIBLING ? node.parentId : node.id
				conductor.navigate('scorecards/' + parentId + '/new', {trigger: true})
			})
		})
	},

	importStructure: function() {
		appDisplay.dialog($.get('api/imports/import-data', { statuses: true }), data => {
			let wizard = new ScorecardItemImportWizard()
			wizard.initialize({
				organizationId: globals.orgId,
				connections: data.connections
			})

			wizard.once('done', () => {
				appDisplay.navView().gardener._onceTreeRendered(() => {
					let tree = appDisplay.navView().gardener.tree
					if (tree.get()) {
						tree.select(tree.get().id, {
							toggleOnSelect: false,
							animate: false
						})
					}
				})
			})
			return wizard._view()
		})
	},

	// override superclass so that we don't select the newly added node
	_addDomainObject: function(model) {
		if (!this._interested(model)) {
			return
		}

		this.toggleTree(true)
	},

	isEditable: function(orgId) {
		return permissions.structure(orgId) || permissions.ownersUpdaters(orgId)
	},

	// #16673 only display "add new scorecard item" if has structure modify permissions
	displayTreeTopToolbar: function (orgId) {
		return permissions.structure(orgId)
	},

	// first two lines copied from nav.js.  Last part customized for scorecards
	// to handle owner/updater permissions correctly
	toggleEditViewState: function(edit) {
		// remember the edit setting, because when we first render this view
		// we don't even have an edit button yet so we need to wait and see if
		// the org actually has any data and then toggle the edit button when
		// the tree is ready
		this._edit = !!edit

		// this is-editing class shows the "New Scorecard Item" button, which
		// we don't want if the user only has owner/updater permission
		var useIsEditingClass = !!edit &&
			(permissions.structure(this.gardener.getOrgId()) || Backbone.history.fragment.endsWith('/edit'))
		this.$el.toggleClass('is-editing', useIsEditingClass)
		this.toggleEditButton(useIsEditingClass)

		if (permissions.structure(this.gardener.getOrgId())) {
			this.gardener.editable(edit)
		}
	},

	_defaultTransientLabel: function(attributes) {
		// Grab the item type separately so that it is affected
		// by terminology changes (substitutions are ignored by
		// configurable terminology) #59485
		let itemType = i18n.get('scorecards.node.' + attributes.type)
		return i18n.get('common.new2', itemType)
	},

	_defaultTransient: function(attributes) {
		return _.assign(Nav.prototype._defaultTransient.apply(this, arguments), {
			type: attributes.type,
			label: this._defaultTransientLabel(attributes),
			// #59542 be sure to specify the icon to use
			icon: attributes.type == 'root' ? 'scorecard' : attributes.type,
			color: 'gray'
		})
	},

	_updateTransientAttributes: function(attributes) {
		// #60119
		// Match changes made to treeOptions.accessors in scorecards-gardener.js
		// so icon property is retrieved correctly
		attributes.icon = attributes?.type
		Nav.prototype._updateTransientAttributes.call(this, attributes)
	},

	saveTransient: function(relativeId, attributes, nextModel) {
		attributes = attributes.attributes || attributes
		Nav.prototype.saveTransient.apply(this, arguments)
		// after adding an scorecard node, immediately show another transient
		// in the tree.  Can't do this in _addDomainObject because we need the
		// relativeId.  Wrap in process.nextTick so the gardener has a chance
		// to record the most recently added position
		process.nextTick(function() {
			this.addTransient(relativeId, nextModel)
		}.bind(this))
	},

	lockedTooltip: function(info) {
		if (locked(info.data, this.gardener.tree)) {
			if (!this._lockedTooltip) {
				this._lockedTooltip = new Tooltip({
					attachTo: info.traveler,
					content: i18n.get('integrity.scorecards.outsideLockPeriod.tooltip'),
					placement: 'right',
					arrow: 'center',
					extraClass: 'has-error'
				}).render()
				this.gardener.tree.on('dndmove',
					this._lockedTooltip.reposition.bind(this._lockedTooltip), true)
				this.gardener.tree.on('dndstop',
					this._lockedTooltip.remove.bind(this._lockedTooltip))
				delete this._lockedTooltip
			}
		}
	},

	_isSelectedItemEditable(selected) {
		return selected && (_.isNil(selected.syncId) || selected.originallyDocked)
	},

	remove: function() {
		Nav.prototype.remove.apply(this, arguments)
		_.invokeMap([this._lockedTooltip, this._disabledAddTooltip, this._rootDockingButton, this._importButton], 'remove')
	},

	_deleteDomainObject (model) {
		if (!this._interested(model)) {
			return
		}

		//for transformed docking nodes, we only allow deletion of descendants not the node itself
		if (_.result(model, 'transformedDocking')) return

		Nav.prototype._deleteDomainObject.apply(this, arguments)
	}

})

export default ScorecardsNav

ScorecardsNav.__filename__ = 'scorecards/scorecards-nav.js'
